module.exports = __webpack_public_path__ + "static/RELATIONSHIP-2a28ad5e0e31eb6a7214418f8a1bf9c6.png";